export function setDatos(state, payload){
    state.datosphp = payload.data.data
    state.error= false
 
}
export function setError (state, payload){
    state.error = true
    state.errorMessage = payload

}